import { AccessFunction } from 'data/accessFunction/accessFunction.types';

export default function getExistingAccessFunctionTags(
  accessFunctionByType: {[key: string]: AccessFunction[]},
  currentAccessFunctionId?: string,
): string[] {

  const accessFunctionsLists: AccessFunction[] = [];

  Object.keys(accessFunctionByType)
    .map((type) => accessFunctionByType[type])
    .forEach((accessFunctions: AccessFunction[]) => accessFunctionsLists.push(...accessFunctions));

  return accessFunctionsLists
    .filter((accessFunction) => accessFunction.id !== currentAccessFunctionId)
    .map((accessFunction) => accessFunction.tag);
}
